module.exports = __webpack_public_path__ + "img/salesnav.c5d502cd.png";